export default function TargetAudienceSection() {
  return (
    <section className="py-20 relative bg-gradient-to-br from-primary-100/50 via-white to-secondary-100/50">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%23e0f2fe%22%20fill-opacity%3D%220.1%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-50"></div>
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-secondary-700 to-primary-700 bg-clip-text text-transparent">
              Pour qui est WeZen ?
            </span>
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto leading-relaxed mb-8 font-medium text-center">
            Que vous soyez débutant en méditation ou pratiquant expérimenté, <span className="text-primary-700 font-semibold">WeZen s'adapte à vous</span>.<br />
            Notre application est idéale pour les jeunes adultes, entrepreneurs, salariés ou retraités souhaitant réduire le stress, trouver plus de sérénité ou booster leur motivation.
          </p>
        </div>
      </div>
    </section>
  );
}
